import { configureCompat } from 'vue'

/**
 * Reusable function to configure Vue compatibility mode,
 * to be reused between the actual app and tests.
 */
export const configureAppCompat = (): void =>
  configureCompat({
    // By default, everything works like it did in Vue2
    MODE: 2,
    // These things, we've switched to work like in Vue3.
    // We wamt to switch over EVERYTHING to Vue3.
    ATTR_ENUMERATED_COERCION: false,
    COMPONENT_ASYNC: false,
    COMPONENT_FUNCTIONAL: false,
    COMPONENT_V_MODEL: false,
    CONFIG_DEVTOOLS: false,
    CONFIG_IGNORED_ELEMENTS: false,
    CONFIG_KEY_CODES: false,
    CONFIG_OPTION_MERGE_STRATS: false,
    CONFIG_PRODUCTION_TIP: false,
    CONFIG_SILENT: false,
    CUSTOM_DIR: false,
    GLOBAL_DELETE: false,
    GLOBAL_EXTEND: false,
    GLOBAL_MOUNT_CONTAINER: false,
    GLOBAL_MOUNT: false,
    GLOBAL_OBSERVABLE: false,
    GLOBAL_PRIVATE_UTIL: false,
    GLOBAL_PROTOTYPE: false,
    GLOBAL_SET: false,
    INSTANCE_CHILDREN: false,
    INSTANCE_DELETE: false,
    INSTANCE_EVENT_EMITTER: false,
    INSTANCE_EVENT_HOOKS: false,
    INSTANCE_LISTENERS: false,
    INSTANCE_SCOPED_SLOTS: false,
    INSTANCE_SET: false,
    OPTIONS_BEFORE_DESTROY: false,
    OPTIONS_DATA_FN: false,
    OPTIONS_DATA_MERGE: false,
    OPTIONS_DESTROYED: false,
    PRIVATE_APIS: false,
    PROPS_DEFAULT_THIS: false,
    // we eliminated this from our app,
    // but vue dev tools sitll use old render function while MODE is 2,
    // so we get a warning
    RENDER_FUNCTION: false,
    V_ON_KEYCODE_MODIFIER: false,

    // These things work like in Vue2.
    // We want to one by one convert these to "false" and deal with issues.
    // Once everything is "false", we can remove vue/compat
    ATTR_FALSE_VALUE: true,
    CONFIG_WHITESPACE: true,
    FILTERS: true,
    INSTANCE_ATTRS_CLASS_STYLE: true,
    INSTANCE_DESTROY: true,
    TRANSITION_CLASSES: true,
    TRANSITION_GROUP_ROOT: true,
    WATCH_ARRAY: true,
  })
